import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DateRangePayload {
  startDate: string;
  endDate: string;
}

@Injectable({ providedIn: 'root' })
export class FilterDateRangeService {
  // Initialize with default values instead of null
  private getDefaultDateRange(): DateRangePayload {
    const today = new Date();
    const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);
    
    return {
      startDate: this.toYMD(ninetyDaysAgo),
      endDate: this.toYMD(today)
    };
  }

  private dateRangeSelectedSubject = new BehaviorSubject<DateRangePayload>(
    this.getDefaultDateRange()
  );
  
  dateRangeSelected$ = this.dateRangeSelectedSubject.asObservable();

  setCustomDateRange(startDate: string, endDate: string): void {
    this.dateRangeSelectedSubject.next({ startDate, endDate });
  }

  private toYMD(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}